import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
  root: {
    "&.MuiGrid-root": {
      // width: "100dvw",
      // height: "100dvh",
      backgroundColor: "white",
      display: "flex",
      flexDirection: "column",
      position: "relative",
    },
  },
  titleInfo: {
    "&.MuiGrid-root": {
      display: "flex",
      justifyContent: "space-between",
      height: "40px",
      width: "100%",
      alignItems: "center",
      paddingInline: "10px",
      backgroundColor: "#F3CCF3",
    },
  },
  contentGrid: {
    "&.MuiGrid-root": {
      display: "flex",
      justifyContent: "space-between",
      height: "calc(100% - 40px)",
      width: "100%",
    },
  },
  tableInput: {
    "&.MuiTextField-root": {
      "& .MuiOutlinedInput-root": {
        // backgroundColor:theme.palette.grey[50],
        "& fieldset": {
          borderColor:"none",
          // borderWidth:'1.4px',
          border: "none",
        },
        '&:hover fieldset': {
          borderColor:"none",
          border:'none',
          // borderWidth:'1.4px',
        },
        "&.Mui-focused fieldset": {
              borderColor: "none !important",
              boxShadow: "none !important",
              borderWidth: "0 !important",
            },
      },
      "& .MuiInputBase-input": {
        color: "none",
        border: "none",
      },
      "& .MuiInputLabel-root": {
        color: "none",
        border: "none",
      },
    },
  },
  tblRoot: {
    "&.MuiTableContainer-root": {
      height: "100%",
      "&::-webkit-scrollbar": {
        width: "10px",
      },
      "&:hover::-webkit-scrollbar": {
        display: "block",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: theme.palette.grey[100],
      },
      "&::-webkit-scrollbar-thumb": {
        border: "2px solid #A9A9A9",
        borderRadius: "20px",
        backgroundColor: theme.palette.common.white,
        backgroundClip: "content-box",
      },
    },
  },
  table: {
    position: "relative",
    // outline: `0.5px solid #ccc`,
    borderRadius: "4px",
  },
  tablrow: {
    "&.MuiTableRow-root": {
      "& .MuiTableCell-root": {
        textAlign: "center",
        padding: "0px",
        paddingBlock:'5px',
        borderRight: `1px solid #ccc`,
      },
    },
  },
  tblHeader: {
    "&.MuiTableHead-root": {
      "& .MuiTableCell-root": {
        fontWeight: 600,
        backgroundColor: "#ba68c8",
        paddingBlock: "6px",
        color: "#fff",
        letterSpacing: 1,
      },
    },
  },
  fieldBox: {
    "&.MuiTextField-root": {
      height: "20px",
      backgroundColor: "red",
    },
  },
  tblContentCellBorder:{
    "&.MuiTableCell-root": {
      textAlign: "center",
      padding: "1px",
      borderBottom: "0.5px solid  #ccc",
      borderLeft:"0.5px solid  #ccc",
      "& .MuiTextField-root": {
        "& .MuiOutlinedInput-root": {
          height: 30,
          padding: 0,
          // backgroundColor: theme.palette.grey[50],
          "& fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
          "&:hover fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
        },
      },
      // border: `1px solid #ccc`,
    },
  },
  tblContentCell: {
    "&.MuiTableCell-root": {
      textAlign: "center",
      padding: "0px",
      borderBottom: "0.5px solid  #ccc",
      "& .MuiTextField-root": {
        "& .MuiOutlinedInput-root": {
          height: 30,
          padding: 0,
          // backgroundColor: theme.palette.grey[50],
          "& fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
          "&:hover fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
        },
      },
      // border: `1px solid #ccc`,
    },
  },
  searchTextField: {
    "&.MuiTextField-root": {
      maxWidth: 400,
      width: "100%",
      [theme.breakpoints.down(768)]: {
        paddingInline: 0,
        width: "100%",
      },
    },
  },
  // customtextfield: {
  //   "&.MuiTextField-root": {
  //     width: "220px",
  //     marginBlockStart: "5px",
  //     [theme.breakpoints.down(728)]: {
  //       width: "100%",
  //     },
  //   },
  // },
  dropDown: {
    zIndex: 1500,
    position: "absolute",
    width: "27%",
  },
  headCell: {
    "&.MuiTableCell-root": {
      borderTop: "1px dashed black",
      borderBottom: "1px dashed black",
      padding : 0,
      paddingBlock : 2,
      color:'black',
      fontSize:15
    },
  },

tblRowCell: {
   '&.MuiTableRow-root':{
    "& .MuiTableCell-root": {
      padding : 0,
      paddingBlock : 2,
      border:'none',
      fontSize:14,
      color : 'black'
    },
   }
  },

  otpContainer: {
    display: "flex",
    justifyContent: "center",
    marginBlock: "25px",
    width: "100%",
  },
  otpField: {
    width: "60px !important",
    height: "60px",
    border: "2px solid #A06EE1",
    borderRadius: "8px",
    marginInline: "15px",
    color:"#000",
    [theme.breakpoints.down("600")]: {
      width: "50px !important",
      height: "40px",
      marginInline: "10px",
    },
    [theme.breakpoints.down("475")]: {
      width: "40px !important",
      height: "40px",
      marginInline: "10px",
    },
    [theme.breakpoints.down("380")]: {
      width: "40px !important",
      height: "40px",
      marginInline: "5px",
    },
  },
}));

// .MuiTableContainer-root .MuiTableBody-root .MuiTableHead-root .MuiTableHead-root .MuiTableRow-root
